import React from "react";
import {useHistory} from "react-router";
import {Box, Dropdown, DropdownButton, DropdownItem, DropdownList} from "@unibuddy/patron";
import styled from "styled-components";
import s from "./MenuList.pcss";

const StyledButton = styled(DropdownButton)`
    background: none;
    border-color: transparent;
    height: 80px;
    width: 90px;
    border-radius: 8px;
    &:hover:not([disabled]), :focus {
        background-color: #DFEDF7;
    }
`;

const _MenuList = ({className, profilePhotoUrl}: { className: string, profilePhotoUrl: string }) => {
    const history = useHistory();
    const menuItems = s.menuItems as string;
    const slide = s.slide as string;
    return (
        <Box className={className}>
            <Dropdown>
                <StyledButton id="dropdownSettings" className={s.button} aria-label={"User details Menu"}>
                    <img className={s.avatar} src={profilePhotoUrl} alt=""/>
                </StyledButton>
                <DropdownList className={`${menuItems} ${slide}`}>
                    <DropdownItem
                        className={s.menuItem}
                        onSelect={() => {
                            history.push("/profile/view");
                        }}
                    >
                        Profile
                    </DropdownItem>
                    <DropdownItem
                        className={s.menuItem}
                        onSelect={() => {
                            history.push("/settings");
                        }}
                    >
                        Settings
                    </DropdownItem>
                    <DropdownItem
                        className={s.menuItem}
                        onSelect={() => {
                            history.push("/auth/logout");
                        }}
                    >
                        Logout
                    </DropdownItem>
                </DropdownList>
            </Dropdown>
        </Box>
    );
};

export default _MenuList;
